import { useState } from "react";
import useEmailLoop from "../hooks/useEmailLoop";
import EmailLoopList from "../components/EmailLoopList";
import EmailLoopModal from "../components/EmailLoopModal";
import EmailLoopMemberModal from "../components/EmailLoopMemberModal";

const EmailLoopListContent = () => {
    const hook = useEmailLoop();
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewList, setPreviewList] = useState([]);

    return (
        <>
            <EmailLoopList
                emailLoopList={hook.emailLoopList}
                isLoading={hook.isLoading}
                onCreate={hook.onCreate}
                onEdit={hook.onEdit}
                onDelete={hook.onDelete}
                onStatus={hook.onStatus}
                onViewMembers={hook.onViewMembers}
            />
            <EmailLoopModal
                open={hook.modalOpen}
                record={hook.editingRecord}
                onCancel={hook.onCloseModal}
                onSubmit={hook.onSubmit}
                previewMemberCount={hook.previewMemberCount}
                onOpenMemberPreview={(members) => {
                    setPreviewList(members);
                    setPreviewOpen(true);
                }}
            />
            <EmailLoopMemberModal
                open={hook.memberModalOpen || previewOpen}
                onCancel={() => {
                    hook.setMemberModalOpen(false);
                    setPreviewOpen(false);
                }}
                members={hook.memberModalOpen ? hook.memberList : previewList}
                loading={hook.memberLoading}
            />
        </>
    );
};

export default EmailLoopListContent;